<template>
  <div
    :style="{
      width: '244px',
      background: 'var(--p-content-background)',
      border: '1px solid var(--p-content-border-color)',
      borderRadius: '10px',
      boxShadow: 'var(--p-overlay-popover-shadow, 0 18px 50px rgba(0,0,0,.35))',
      padding: '10px',
    }"
  >
    <div :style="{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }">
      <button :style="calNav" @click="view = new Date(y, mo - 1, 1)"><i class="pi pi-chevron-left" :style="{ fontSize: '11px' }" /></button>
      <span :style="{ fontSize: '12.5px', fontWeight: 700, color: 'var(--p-text-color)' }">{{ MONTHS[mo] }} {{ y }}</span>
      <button :style="calNav" @click="view = new Date(y, mo + 1, 1)"><i class="pi pi-chevron-right" :style="{ fontSize: '11px' }" /></button>
    </div>
    <div :style="{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: '2px', marginBottom: '3px' }">
      <span v-for="d in DOW" :key="d" :style="{ textAlign: 'center', fontSize: '10px', fontWeight: 700, color: 'var(--p-surface-400)' }">{{ d }}</span>
    </div>
    <div :style="{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: '2px' }">
      <template v-for="(d, i) in cells" :key="i">
        <button v-if="d" :style="cellStyle(d)" @click="emit('select', fmtDate(d))">{{ d.getDate() }}</button>
        <span v-else />
      </template>
    </div>
    <div :style="{ display: 'flex', justifyContent: 'space-between', marginTop: '8px', paddingTop: '8px', borderTop: '1px solid var(--p-content-border-color)' }">
      <button :style="calFoot" @click="emit('select', fmtDate(today))">Today</button>
      <button :style="calFoot" @click="emit('select', null)">Clear</button>
    </div>
  </div>
</template>

<script setup>
// Calendar popover (PrimeVue DatePicker-equivalent panel). Ported from
// fql-search.jsx CalendarPanel. Emits select(dateStr | null).
import { ref, computed } from 'vue'

const props = defineProps({
  value: { type: String, default: '' },
})
const emit = defineEmits(['select'])

const pad2 = (n) => String(n).padStart(2, '0')
const fmtDate = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
const parseDate = (s) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || '')
  return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null
}
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
const DOW = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
const calNav = { background: 'transparent', border: 0, cursor: 'pointer', color: 'var(--p-text-muted-color)', padding: '4px', display: 'flex', borderRadius: '6px' }
const calFoot = { background: 'transparent', border: 0, cursor: 'pointer', fontSize: '11.5px', fontWeight: 700, color: 'var(--p-primary-700)', fontFamily: 'inherit', padding: '2px 4px' }

const today = new Date()
const sel = computed(() => parseDate(props.value))
const view = ref(sel.value || today)
const y = computed(() => view.value.getFullYear())
const mo = computed(() => view.value.getMonth())
const cells = computed(() => {
  const startDow = new Date(y.value, mo.value, 1).getDay()
  const dim = new Date(y.value, mo.value + 1, 0).getDate()
  const out = []
  for (let i = 0; i < startDow; i++) out.push(null)
  for (let d = 1; d <= dim; d++) out.push(new Date(y.value, mo.value, d))
  while (out.length % 7) out.push(null)
  return out
})
const same = (a, b) => a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate()
const cellStyle = (d) => ({
  aspectRatio: '1',
  border: `1px solid ${same(d, today) && !same(d, sel.value) ? 'var(--p-primary-500)' : 'transparent'}`,
  borderRadius: '7px',
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: same(d, sel.value) ? 'var(--p-primary-500)' : 'transparent',
  color: same(d, sel.value) ? 'var(--p-primary-950)' : 'var(--p-text-color)',
  fontWeight: same(d, sel.value) ? 700 : 500,
})
</script>
